/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {Breadcrumb, Modal} from "antd";
import {Link} from "react-router-dom";
import {ApiTable} from "../components/table";
import {useAppDispatch, useAppSelector} from "../store";
import {openDrawer} from "../reducers/drawers-reducer";
import {DeviceModel} from "../core/datamodel";
import {CustomButton} from "../components/buttons";
import {IconSet} from "../components/icons";
import {get} from "../core/request";

export default function DeviceModelListView(props: any) {
    const dispatch = useAppDispatch();

    return (
        <>
            <Breadcrumb style={{paddingTop: 6, paddingBottom: 6}}>
                <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item>Geräte-Modelle</Breadcrumb.Item>
            </Breadcrumb>

            <ApiTable
                title={<><IconSet type='models'/> Geräte-Modelle</>}
                id="GeräteModelle"
                url="devicemodels"
                reloadSignals={[useAppSelector(state => state.reloadSignals.devicemodel)]}
                searchable
                buttons={
                    <CustomButton
                        mode={'add'}
                        tooltip={"Neues Gerätemodell hinzufügen"}
                        onClick={() => dispatch(openDrawer({key: 'devicemodel', object: new DeviceModel({})}))}
                    />
                }
                tableProps={{
                    rowClassName: () => "cursor-pointer",
                    onRow: (record: any, rowIndex: any) => {
                        return {
                            onClick: () => {
                                get("devicemodels/" + record.key).done(
                                    (response) => {
                                        let deviceModel = new DeviceModel(response.data.devicemodel)
                                        dispatch(openDrawer({key: 'devicemodel', object: deviceModel}))
                                    }
                                ).fail(() => {
                                    Modal.error({title: "Fehler", content: "Gerätemodell kann nicht bearbeitet werden!"})
                                })
                            }
                        }
                    }
                }}
            />
        </>
    )
}